/**
 * Created by Ning Jiang on 6/12/2019.
 */

import {MultiSprites} from "@nolimitcity/slot-game/bin/core/displayobject/MultiSprites";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Back, SlowMo, TimelineLite, TweenLite} from "gsap";
import {PixiesVsPiratesInitialWinCountUp} from "../winpresentation/initial/PixiesVsPiratesInitialWinCountUp";
import {BitmapTextStyleData} from "../winpresentation/initial/PPWaysWonGFXText";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {PixiesVsPiratesParsedGameData} from "../server/parseddata/PixiesVsPiratesParsedGameData";
import {PixiesVsPirates} from "../PixiesVsPirates";

export class FreespinOutroContainer extends PIXI.Container {

    private _tempStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 46,
        fontWeight : FontWeight.BOLD,
        align : "center",
        dropShadow : true,
        dropShadowAlpha : 0.6,
        dropShadowAngle : 89.5,
        dropShadowBlur : 6,
        dropShadowColor : "#1a1740",
        dropShadowDistance : 3,
        fill : [
            "#fff7e8",
            "#fffdec",
            "#fff0aa",
            "#ffc733"
        ],
        miterLimit : 7,
        stroke : "#bd1e96",
        strokeThickness : 1
    };

    private readonly _winNumberStyle:BitmapTextStyleData = {
        fontName : "NumbersWinCountUp",
        fontSize : 18,
        tint : 0xffffff
    };

    private _totalWinText:PIXI.Text;
    private _spinsPlayed:PIXI.Text;
    private _pixiesCollected:PIXI.BitmapText;
    private _piratesCollected:PIXI.BitmapText;
    private _pirateSprite:MultiSprites;
    private _pixieSprite:MultiSprites;
    private _picker:PIXI.Sprite;
    private _battleRoundsWon:PIXI.Container;
    private _pickerAnimationOffset:number = 5;
    private _pickerPositionY:number = -150;
    private _totalWinCountUp:PixiesVsPiratesInitialWinCountUp;
    private _glowRays:PIXI.Sprite;
    private _isShowing:boolean = false;


    public set totalWinCountUp(value:PixiesVsPiratesInitialWinCountUp) {
        if(this._totalWinCountUp != null) {
            return;
        }
        this._totalWinCountUp = value;
        this._totalWinCountUp.position.set(0, -245);
        this.addChild(this._totalWinCountUp);
    }

    private get pickerPositionY():number {
        return this._pickerPositionY;
    }

    private set pickerPositionY(value:number) {
        this._picker.y = value;
    }

    constructor() {
        super();

        const backDarkGradient:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("darkGradient")[0]);
        backDarkGradient.anchor.set(0.5);
        backDarkGradient.scale.set(13, 5);
        backDarkGradient.alpha = 0.7;
        backDarkGradient.position.set(0, -236);
        this.addChild(backDarkGradient);

        this._totalWinText = new PIXI.Text(Translation.translate("Total Win"), this._tempStyle);
        this._totalWinText.anchor.set(0.5);
        this._totalWinText.position.set(0, -305);
        this.addChild(this._totalWinText);

        this._spinsPlayed = new PIXI.Text("", this._tempStyle);
        this._spinsPlayed.style.fontSize = 20;
        this._spinsPlayed.style.fontWeight = FontWeight.NORMAL;
        // this._spinsPlayed.anchor.set(1, 0);

        this._spinsPlayed.position.set(0, 0);
        this.addChild(this._spinsPlayed);

        this._glowRays = new PIXI.Sprite(GameResources.getTextures("winGlow")[0]);
        this._glowRays.blendMode = PIXI.BLEND_MODES.ADD;
        this._glowRays.scale.set(3.5, 3.5);
        this.addChild(this._glowRays);

        this._pixieSprite = new MultiSprites({
            win : {
                textures : GameResources.getTextures("pixieOutroWin"),
                anchor : [1, 0.5]
            },
            defeat : {
                textures : GameResources.getTextures("pixieOutroDefeat"),
                anchor : [1, 0.55]
            }
        });
        this._pixieSprite.position.set(25, 95);
        this.addChild(this._pixieSprite);

        this._pirateSprite = new MultiSprites({
            win : {
                textures : GameResources.getTextures("pirateOutroWin"),
                anchor : [0, 0.5]
            },
            defeat : {
                textures : GameResources.getTextures("pirateOutroDefeat"),
                anchor : [0, 0.5]
            }
        });
        this._pirateSprite.position.set(-35, 95);
        this.addChild(this._pirateSprite);

        this._picker = new PIXI.Sprite(GameResources.getTextures("picker")[0]);
        this._picker.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(this._picker);

        this._pixiesCollected = new PIXI.BitmapText("", this._winNumberStyle);
        (<PIXI.Point>this._pixiesCollected.anchor).set(1, 0.5);
        this._pixiesCollected.position.set(-276, 55);
        this.addChild(this._pixiesCollected);
        this._pixiesCollected.updateTransform();

        this._piratesCollected = new PIXI.BitmapText("", this._winNumberStyle);
        (<PIXI.Point>this._piratesCollected.anchor).set(0, 0.5);
        this._piratesCollected.position.set(280, 55);
        this.addChild(this._piratesCollected);
        this._piratesCollected.updateTransform();

        this._battleRoundsWon = new PIXI.Container();
        this._battleRoundsWon.position.set(0, 200);
        this.addChild(this._battleRoundsWon);

        const spinsWonBanner:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("spinWonTextBanner")[0]);
        spinsWonBanner.anchor.set(0.5, 0);
        this._battleRoundsWon.addChild(spinsWonBanner);
        let winAnotherRound:PIXI.Text = new PIXI.Text(Translation.translate("YOU WON!"), this._tempStyle);
        winAnotherRound.style.fontSize = 30;
        winAnotherRound.anchor.set(0.5);
        winAnotherRound.position.set(0, 117);
        this._battleRoundsWon.addChild(winAnotherRound);

        const letsGoAnotherRound:PIXI.Text = new PIXI.Text(Translation.translate("Let's go one more time!"), this._tempStyle);
        letsGoAnotherRound.style.fontSize = 30;
        letsGoAnotherRound.anchor.set(0.5);
        letsGoAnotherRound.position.set(0, 148);
        this._battleRoundsWon.addChild(letsGoAnotherRound);

        const battleRoundsText:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("battleRoundsText")[0]);
        battleRoundsText.anchor.set(0.5);
        battleRoundsText.position.set(0, 68);
        this._battleRoundsWon.addChild(battleRoundsText);

        this.close();
    }

    public show(totalWin:number, spinsPlayed:number, pixiesCollected:number, piratesCollected:number, winAnotherRound:boolean, playerFSSelection:number, totalWinBelowStake: boolean):TimelineLite {
        // #272
        const duration: number = (totalWinBelowStake ? 0 : 1);

        this._isShowing = true;

        this._spinsPlayed.text = `${Translation.translate("Spins Played:")} ${spinsPlayed.toString()}`;
        this._pixiesCollected.text = pixiesCollected.toString();
        this._piratesCollected.text = piratesCollected.toString();
        debugger;
        this._totalWinText.visible = !totalWinBelowStake;

        if(playerFSSelection === 1) {
            this._picker.anchor.set(1, 1);
            this._picker.position.x = -90;
        } else {
            this._picker.anchor.set(0, 1);
            this._picker.position.x = 90;
        }
        this.playPicker();

        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            this._totalWinCountUp.getCountUpAnimation(0, totalWin, duration, 1),
            this._pixieSprite.playSprite("win",
                {duration : 0.2, vars : [{toVars : {alpha : 1}}]},
                {duration : 0, vars : [{toVars : {alpha : 0}}]}),
            this._pirateSprite.playSprite("win",
                {duration : 0.2, vars : [{toVars : {alpha : 1}}]},
                {duration : 0, vars : [{toVars : {alpha : 0}}]})
        ]);

        let winIndex:number = pixiesCollected === piratesCollected ? playerFSSelection : (pixiesCollected > piratesCollected ? 1 : 2);
        const loser:MultiSprites = winIndex === 1 ? this._pirateSprite : this._pixieSprite;
        timeline.add([
            TweenLite.fromTo(this._glowRays, 0.3,
                {alpha : 0},
                {
                    alpha : 1,
                    onStart : () => {
                        this.setGlowPosition(winIndex === 1);
                        this._glowRays.visible = true;
                    }
                }),
            () => {
                loser.playSprite("defeat",
                    {duration : 0.5, vars : [{fromVars : {alpha : 0}, toVars : {alpha : 1}}]},
                    {duration : 0.5, vars : [{toVars : {alpha : 0}}]}
                );
                TweenLite.fromTo(this._totalWinCountUp.scale, 0.3,
                    {x : 1.4, y : 1.4},
                    {x : 1, y : 1, ease : Back.easeIn.config(2)}
                );
            }
        ]);

        if(winAnotherRound) {
            Logger.logDev("win another round!");
            timeline.add(TweenLite.fromTo(this._battleRoundsWon, 0.3,
                {alpha : 0},
                {
                    alpha : 1,
                    onStart : () => {
                        Logger.logDev("battle round win visible!");
                        this._battleRoundsWon.visible = true;
                    }
                }));
        }

        return timeline;
    }

    private setGlowPosition(isPixie:boolean):void {
        if(isPixie) {
            this._glowRays.anchor.set(1, 0.5);
            this._glowRays.position.set(104, 8);
        } else {
            this._glowRays.anchor.set(0, 0.5);
            this._glowRays.position.set(-120, 8);
        }
    }

    private playPicker():void {
        if(!this._isShowing) {
            return;
        }

        TweenLite.to(this, 1,
            {
                pickerPositionY : this._pickerPositionY + this._pickerAnimationOffset,
                ease : SlowMo.ease.config(0.1, 0.1, true),
                onComplete : () => this.playPicker()
            });
    }

    public updateElementsPosition(width:number, height:number, orientation:string):void {
        if(orientation === "portrait") {
            this._spinsPlayed.position.set(-70, 400);
        } else {
            this._spinsPlayed.position.set(-width * 0.5, height * 0.45);
        }
    }

    public close():void {
        this._isShowing = false;
        this._glowRays.visible = false;
        this._battleRoundsWon.visible = false;
        this._pixieSprite.position.set(25, 95);
    }
}
